// extracted by mini-css-extract-plugin
export var falconContainer = "_vy-2";
export var offerCenter = "_vy-0";
export var roktContainer = "_vy-1";